module.exports = __webpack_public_path__ + "img/espana.475d129c.jpg";